import { Button, Modal, Row, Space } from "antd";
import { ModalButtonsProps } from "@/types";
import useMediaButton from "./useMediaButton";

type ModalButtonProps = {
	buttonLabel: React.ReactNode;
	modalTitle: React.ReactNode;
	children: React.ReactNode;
	buttons: ModalButtonsProps[];
	buttonType: "primary" | "default" | "link" | "text" | "ghost";
	buttonAriaLabel?: string;
	buttonDisabled?: boolean;
	buttonLoading?: boolean;
	dangerButton: boolean;
};

const ModalButton = ({
	buttonLabel,
	buttonAriaLabel,
	modalTitle,
	children,
	buttons,
	buttonType,
	buttonDisabled,
	dangerButton,
	buttonLoading,
}: ModalButtonProps) => {
	const { showModal, isModalOpen, handleButtonClicked } = useMediaButton();
	return (
		<>
			<Button
				type={buttonType}
				aria-label={buttonAriaLabel}
				onClick={showModal}
				danger={dangerButton}
				disabled={buttonDisabled}
				loading={buttonLoading}
			>
				{buttonLabel}
			</Button>
			<Modal
				open={isModalOpen}
				title={modalTitle}
				centered
				bodyStyle={{ minHeight: "50px", padding: 20 }}
				footer={
					<Row justify="center">
						<Space size="large" direction="horizontal" wrap>
							{buttons.map(
								({
									title,
									onClick,
									type,
									close,
									danger,
									loading,
									disabled,
									style,
								}) => (
									<Button
										key={title}
										type={type}
										onClick={
											close
												? handleButtonClicked
												: async (e: React.MouseEvent<HTMLElement>) => {
														await onClick?.(e);
														handleButtonClicked();
												  }
										}
										danger={danger}
										loading={loading}
										disabled={disabled}
										style={style}
									>
										{title}
									</Button>
								),
							)}
						</Space>
					</Row>
				}
				closable={false}
			>
				{children}
			</Modal>
		</>
	);
};

export default ModalButton;
